/* Import Famys Premium v4 — compatibilidad de checkout desde vista previa de Shopify */
(function () {
  'use strict';

  function runningInsidePreviewFrame() {
    try {
      return window.top !== window.self;
    } catch (error) {
      return true;
    }
  }

  function prepareCheckoutForms() {
    if (!runningInsidePreviewFrame()) return;

    var forms = [
      document.getElementById('cart'),
      document.getElementById('CartDrawer-Form'),
      document.getElementById('webicart')
    ];

    forms.forEach(function (form) {
      if (form) form.setAttribute('target', '_top');
    });

    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function (control) {
      control.addEventListener('click', function () {
        var formId = control.getAttribute('form');
        var form = formId ? document.getElementById(formId) : control.closest('form');
        if (form) form.setAttribute('target', '_top');
      }, { capture: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareCheckoutForms);
  } else {
    prepareCheckoutForms();
  }

  document.addEventListener('shopify:section:load', prepareCheckoutForms);
})();
